import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { initCtaTracking } from "@/lib/analytics";

// One $17 CTA. Carries data-cta-location=seo_<slug> so the delegated GA4
// click_primary_cta listener fires with the right location.
export const SeoCta = ({ slug }) => {
  useEffect(() => { initCtaTracking(); }, []);
  return (
  <div className="my-2">
    <Link
      to="/get-started"
      data-cta-location={`seo_${slug}`}
      data-testid={`seo-cta-${slug}`}
      className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#F5A623] px-6 py-3.5 font-heading text-base font-extrabold text-[#0B132B] transition-transform duration-200 hover:-translate-y-0.5"
    >
      Get CommandCenterADHD for $17, one time
      <ArrowRight className="h-4 w-4" aria-hidden="true" />
    </Link>
    <p className="mt-2 text-[13px] text-[#8FA3BC]">
      One time purchase. No subscription. Future updates included. 30 day money back guarantee.
    </p>
  </div>
  );
};

// FAQ list. Question in summary, answer in a paragraph, both always in the DOM
// so the prerender snapshot and the FAQPage JSON-LD match the visible text.
export const SeoFaq = ({ faqs }) => (
  <div className="space-y-3" data-testid="seo-faq">
    {faqs.map((f, i) => (
      <details
        key={i}
        className="group rounded-xl border border-white/10 bg-[#0F1B33] p-4"
        data-testid={`seo-faq-${i}`}
      >
        <summary className="cursor-pointer list-none font-heading text-base font-bold text-white marker:hidden">
          {f.q}
        </summary>
        <p className="mt-2 text-[15px] leading-relaxed text-[#BFD4E8]">{f.a}</p>
      </details>
    ))}
  </div>
);

// Contextual internal links with descriptive anchors (crawlability + GEO).
export const SeoRelated = ({ links }) => (
  <div className="mt-4 border-t border-white/10 pt-6" data-testid="seo-related">
    <p className="font-heading text-sm font-bold uppercase tracking-[0.12em] text-[#8FA3BC]">Keep reading</p>
    <ul className="mt-3 space-y-2">
      {links.map((l, i) => (
        <li key={i}>
          <Link
            to={l.to}
            data-testid={`seo-related-${i}`}
            className="font-semibold text-[#7FC8A9] underline decoration-[#7FC8A9]/40 underline-offset-2 hover:text-white"
          >
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
